import React from 'react';
import { Box, Text, HStack } from 'native-base';

/**
 * Tooltip/banner shown when a venue owner tries to interact with
 * Doshii-synced menu items. Directs them to Doshii's Menu Manager.
 */
function DoshiiMenuTooltip() {
  return (
    <Box
      bg="blue.100"
      p={4}
      borderRadius="md"
      borderWidth={1}
      borderColor="blue.300"
      mb={4}
    >
      <HStack alignItems="center" space={2} mb={1}>
        <Text fontSize="lg" role="img" aria-label="lock">&#128274;</Text>
        <Text fontSize="sm" fontWeight="bold" color="blue.800">
          Menu managed by POS
        </Text>
      </HStack>
      <Text fontSize="sm" color="blue.700">
        Your menu items are automatically synced from your POS system. To edit
        menu items, prices, or availability, please make changes via{' '}
        <Text fontWeight="bold">your POS Menu Manager</Text>.
        Changes will sync to Piatto automatically.
      </Text>
      <Text fontSize="xs" color="blue.600" mt={2}>
        You can still edit accessibility information (allergens, dietary flags)
        for each item directly in Piatto.
      </Text>
    </Box>
  );
}

export default DoshiiMenuTooltip;
